(function ()
{
    'use strict';

    angular.module('app').config(config);

    /** @ngInject */
    function config($translateProvider, paginationTemplateProvider, ivhTreeviewOptionsProvider) {
        
        /**
         * Configuração do mecanismo de paginação. Permite a customização do template de paginação usado
         * na visualização de resultados em lista.
         * 
         * Adicionado inicialmente para suprir demanda do processos por paginação no backend.
         * 
         * @autor Rodrigo Barreiros
         * 
         * @see core.module.js
         */
        paginationTemplateProvider.setPath('app/custom/templates/pagination.tpl.html');

        /**
         * Configuração do mecanismo de visualização em árvore. Permite a customização de templates 
         * relacionados à estrutura da árvore.
         * 
         * Adicionado inicialmente para suprir demanda do processos por visualização 
         * hierárquica da cadeia de incidentes.
         * 
         * @autor Rodrigo Barreiros
         * 
         * @see core.module.js
         */
        ivhTreeviewOptionsProvider.set({
            twistieCollapsedTpl: '<span class="icon-chevron-down s16 arrow md-accent-fg"></span>',
            twistieExpandedTpl: '<span class="icon-chevron-right s16 arrow md-accent-fg"></span>',
            twistieLeafTpl: '<span class="icon-checkbox-blank-circle-outline md-accent-fg twistie-leaf"></span>'
        });

    }

})();